/** E-mail de suporte/feedback exibido no app (Ajustes › Enviar feedback). */
export const SUPPORT_EMAIL = 'suporte@kontto.com.br';

export const AccountType = {
    CHECKING: 'checking',
    SAVINGS: 'savings',
    WALLET: 'wallet',
    DIGITAL: 'digital',
    INVESTMENT: 'investment',
    OTHER: 'other',
} as const;

export const TransactionType = {
    INCOME: 'income',
    EXPENSE: 'expense',
    TRANSFER: 'transfer',
    ADJUSTMENT: 'adjustment',
} as const;

export const CardBrand = {
    VISA: 'visa',
    MASTERCARD: 'mastercard',
    ELO: 'elo',
    AMEX: 'amex',
    HIPERCARD: 'hipercard',
    OTHER: 'other',
} as const;

export const InvoiceStatus = {
    OPEN: 'open',
    CLOSED: 'closed',
    PAID: 'paid',
    PARTIAL: 'partial',
    OVERDUE: 'overdue',
} as const;

// Unidades base de recorrência. Quinzenal/bimestral/trimestral/semestral são
// (unidade base + interval), não unidades próprias — ver docs/adr/0002.
export const Frequency = {
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    ANNUAL: 'annual',
} as const;

// Valores compostos legados (pré-normalização). Ainda aceitos como fallback
// defensivo em lib/recurrence; a migração colapsa os dados em base + interval.
export const LegacyCompoundFrequency = {
    BIWEEKLY: 'biweekly',
    BIMONTHLY: 'bimonthly',
    QUARTERLY: 'quarterly',
    SEMIANNUAL: 'semiannual',
} as const;

export const BudgetPeriod = {
    WEEKLY: 'weekly',
    BIWEEKLY: 'biweekly',
    MONTHLY: 'monthly',
} as const;

export const AdjustmentType = {
    ACCOUNT_BALANCE: 'account_balance',
    GOAL_DEPOSIT: 'goal_deposit',
    INVOICE_CREDIT: 'invoice_credit',
    INVOICE_MANUAL_ENTRY: 'invoice_manual_entry',
    INVOICE_MANUAL_ADJUSTMENT: 'invoice_manual_adjustment',
    INVOICE_REMAINDER: 'invoice_remainder',
    INVOICE_EXPENSE: 'invoice_expense',
    INVOICE_PAYMENT: 'invoice_payment',
} as const;

// PARTIAL_PAYMENT: pagamento parcial de UMA parcela — o valor pago sai como
// lançamento confirmado próprio e a parcela regular continua pendente com o
// restante. Não é REGULAR_INSTALLMENT de propósito: senão contaria como uma
// parcela a mais no progresso e no cronograma (ver ADR 0055).
export const FinancingEntryType = {
    REGULAR_INSTALLMENT: 'regular_installment',
    EXTRA_PREPAYMENT: 'extra_prepayment',
    PARTIAL_PAYMENT: 'partial_payment',
} as const;

// Tipo do contrato: muda só rótulo e quais campos fazem sentido — o modelo
// (contrato + série de parcelas + abatimentos) é o mesmo. Ver ADR 0055.
export const FinancingKind = {
    FINANCING: 'financing',
    LOAN: 'loan',
} as const;

// Lançamentos vinculados a empréstimo a pessoa ("Quem me deve").
// disbursement/receipt movem caixa mas NÃO são despesa/receita (troca de ativo);
// scheduled_receipt é a entrada esperada da data combinada (pendente);
// excess e write_off são receita/despesa de verdade, com categoria.
export const PersonalLoanEntryType = {
    DISBURSEMENT: 'disbursement',
    SCHEDULED_RECEIPT: 'scheduled_receipt',
    RECEIPT: 'receipt',
    EXCESS: 'excess',
    WRITE_OFF: 'write_off',
} as const;

// Entry types de empréstimo que ficam FORA dos relatórios de receita/despesa
// por categoria e da análise — é principal do recebível, não resultado.
export const PERSONAL_LOAN_PRINCIPAL_ENTRY_TYPES = [
    PersonalLoanEntryType.DISBURSEMENT,
    PersonalLoanEntryType.SCHEDULED_RECEIPT,
    PersonalLoanEntryType.RECEIPT,
] as const;

export type AccountTypeValue = typeof AccountType[keyof typeof AccountType];
export type TransactionTypeValue = typeof TransactionType[keyof typeof TransactionType];
export type CardBrandValue = typeof CardBrand[keyof typeof CardBrand];
export type InvoiceStatusValue = typeof InvoiceStatus[keyof typeof InvoiceStatus];
export type FrequencyValue = typeof Frequency[keyof typeof Frequency];
export type BudgetPeriodValue = typeof BudgetPeriod[keyof typeof BudgetPeriod];
export type AdjustmentTypeValue = typeof AdjustmentType[keyof typeof AdjustmentType];
export type FinancingEntryTypeValue = typeof FinancingEntryType[keyof typeof FinancingEntryType];
export type FinancingKindValue = typeof FinancingKind[keyof typeof FinancingKind];
export type PersonalLoanEntryTypeValue = typeof PersonalLoanEntryType[keyof typeof PersonalLoanEntryType];
